export const PORTAL_PAGES = new Set(['login', 'find', 'profile', 'edit-profile', 'family', 'history', 'dose-helper', 'prescriptions', 'refills', 'orders', 'ai', 'chat', 'reminders', 'rewards', 'shop', 'trackers', 'bills', 'verification', 'verify-id', 'clinical', 'adverse-reactions', 'invite']);

export function parsePortalPath(pathname, search = '') {
  const parts = pathname.replace(/^\/portal\/?/, '').split('/').filter(Boolean);
  const query = new URLSearchParams(search);
  let pharmacySlug = '', branchSlug = '', page = '';
  if (parts.length && !PORTAL_PAGES.has(parts[0])) pharmacySlug = parts.shift();
  if (pharmacySlug && parts.length && !PORTAL_PAGES.has(parts[0])) branchSlug = parts.shift();
  if (parts.length) page = parts.shift();
  const invalid = parts.length > 0 || (page && !PORTAL_PAGES.has(page));
  const pharmacyId = pharmacySlug ? '' : query.get('pharmacy') || '';
  const branchId = branchSlug ? '' : query.get('branch') || '';
  const base = `/portal${pharmacySlug ? `/${pharmacySlug}` : ''}${branchSlug ? `/${branchSlug}` : ''}`;
  const selection = new URLSearchParams();
  if (pharmacyId) selection.set('pharmacy', pharmacyId);
  if (branchId) selection.set('branch', branchId);
  const suffix = selection.size ? `?${selection}` : '';
  return { pharmacySlug, branchSlug, pharmacyId, branchId, page, invalid, base, suffix,
    key: JSON.stringify([pharmacySlug, branchSlug, pharmacyId, branchId]),
    href: (target = '') => `${base}${target ? `/${target.replace(/^\/portal\/?/, '')}` : ''}${suffix}` };
}

export function destinationPath(pharmacy, branch, page = '') {
  const query = new URLSearchParams();
  let path = '/portal';
  if (pharmacy?.slug) path += `/${pharmacy.slug}`;
  else if (pharmacy) query.set('pharmacy', pharmacy.tenant_id);
  if (branch?.slug && pharmacy?.slug) path += `/${branch.slug}`;
  else if (branch) query.set('branch', branch.tenant_id);
  if (page) path += `/${page}`;
  return path + (query.size ? `?${query}` : '');
}